import { PageIdInterface, ProjectIdWithType } from 'types/store';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { axiosClient } from 'services/ApiClient';

export const loadGroupsVisualisationsByPageId = (
  { projectId, pageId }: ProjectIdWithType<PageIdInterface>,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<FastBoard.API.GroupsVisualisationsV3>> =>
  axiosClient.get(`/api/v3/project/${projectId}/page/${pageId}/group-visualisations`, config);
